module.exports = __webpack_public_path__ + "img/fundo.562d79be.png";